import React, { useState } from 'react';
import Logo from '../../../assets/logoown.jpg';
import Bars from '../../../assets/bars.png';
import { Link as RouterLink } from 'react-router-dom'; // Import React Router's Link
import './Header.css';

const Header = () => {
  const mobile = window.innerWidth <= 768 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <div className="header">
      <img src={Logo} alt="" className="logo" />
      {menuOpened === false && mobile === true ? (
        <div
          style={{
            backgroundColor: 'var(--appColor)',
            padding: '0.5rem',
            borderRadius: '5px',
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{
              width: '1.5rem',
              height: '1.5rem',
            }}
          />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <RouterLink to="/" onClick={() => setMenuOpened(false)}>
              Home
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/workout" onClick={() => setMenuOpened(false)}>
              Workout
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/diet" onClick={() => setMenuOpened(false)}>
              Diet
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/coach-consultant" onClick={() => setMenuOpened(false)}>
              Coach Consultant
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/recommendation" onClick={() => setMenuOpened(false)}>
            Recommendation
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/Contact" onClick={() => setMenuOpened(false)}>
              Contact
            </RouterLink>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
